import { TenantForm } from "components";

export default function NewTenant() {
	return (
		<div className="tenant-page">
			<TenantForm isEditForm={false} />
		</div>
	);
}
